import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm, getFormValues } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import { connect } from 'react-redux';
import SubmitButton from 'form/SubmitButton';
import Select from 'form/Select';
import { query } from 'redux-bees';
import Tooltip from 'components/Tooltip';

@withRouter

@query('account', api.getAccount)
@connect((state, props) => ({
  initialValues: props.site.attributes,
  formValues: getFormValues('Cf7Settings')(state),
}))

@reduxForm({
  form: 'Cf7Settings',
  onSubmit(values, dispatch, props) {
    const { site } = props;

    return dispatch(api.setCustomFc7Sender(
      { id: site.id },
      {
        data: {
          type: 'site',
          attributes: {
            smtpAddress: values.smtpAddress,
            smtpPort: values.smtpPort,
            smtpDomain: values.smtpDomain,
            smtpUserName: values.smtpUserName,
            smtpPassword: values.smtpPassword,
            smtpAuthentication: values.smtpAuthentication,
            smtpEnableStarttlsAuto: values.smtpEnableStarttlsAuto,
            smtpOpenSslVerifyMode: values.smtpOpenSslVerifyMode,
            smtpSsl: values.smtpSsl,
            smtpTsl: values.smtpTsl,
            cf7CustomSender: values.cf7CustomSender,
          },
        },
      },
    ))
    .then(() => {
      props.history.push(`/site/${site.id}/settings`);
      dispatch(notice('Settings.success'));
    })
    .catch((response) => {
      dispatch(alert('Cf7Settings.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class Cf7Settings extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
    account: PropTypes.object.isRequired,
    formValues: PropTypes.object,
  }

  render() {
    const { account, handleSubmit, submitting, error, dirty, formValues } = this.props;

    return (
      <div className="Site__area">
        <div className="Site__area__header">
          <div className="Site__area__header__title">
            CF7 settings
          </div>
        </div>
        <div className="Site__area__content">
          <div className="grid">
            <div className="grid__item space--bottom-2">
              <div className="Settings__area__item">
                <div className="Settings__area__item__key">
                  Zapier API Key:
                </div>
                <strong>{account && account.attributes.zapierApiKey}</strong>
              </div>
              <div className="Settings__area__item">
                <div className="Settings__area__item__key">
                  Zapier App
                  {' '}
                  <Tooltip label="Click for a sample video guide">
                    <a href="https://www.hardypress.com/guides/how-to-integrate-cf7-with-mailchimp-on-hardypress-video/" target="_blank" rel="noopener noreferrer">
                      <i className="icon--question-circle" />
                    </a>
                  </Tooltip>
                </div>
                <a href="https://zapier.com/developer/public-invite/2281/bfe38b7f828ec3810a6d5b704c64c9fe/" target="_blank" rel="noopener noreferrer">Invitation link</a>
              </div>
            </div>
          </div>
          <Form onSubmit={handleSubmit}>
            <div className="grid">
              <div className="grid__item space--bottom-2">
                <Field label="Settings.cf7CustomSender" name="cf7CustomSender" placeholder="info@example.com">
                  <input type="text" />
                </Field>
              </div>
              { formValues && formValues.cf7CustomSender &&
                <div className="Settings__area__smtp">
                  <div className="grid__item width-12-12 space--bottom-2 Settings__area__smtp__title">
                    <strong>
                      SMTP settings
                    </strong>
                    {' '}
                    (check
                    {' '}
                    <a href="https://docs.gitlab.com/omnibus/settings/smtp.html" target="_blank" rel="noopener noreferrer">here</a>
                    {' '}
                    for some provider configuration sample)
                  </div>
                  <div className="grid__item width-8-12 space--bottom-2">
                    <Field label="Settings.smtpAddress" name="smtpAddress" placeholder="smtp.gmail.com">
                      <input type="text" />
                    </Field>
                  </div>
                  <div className="grid__item width-4-12 space--bottom-2">
                    <Field label="Settings.smtpPort" name="smtpPort" placeholder="587">
                      <input type="text" />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpUserName" name="smtpUserName" placeholder="info@example.com">
                      <input type="text" />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpPassword" name="smtpPassword" placeholder="yourpassword">
                      <input type="text" />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpDomain" name="smtpDomain" placeholder="example.com">
                      <input type="text" />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpAuthentication" name="smtpAuthentication">
                      <Select
                        clearable={false}
                        options={[
                          { value: 'plain', label: 'PLAIN' },
                          { value: 'login', label: 'LOGIN' },
                          { value: 'cram_md5', label: 'CRAM-MD5' },
                        ]}
                      />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpOpensslVerifyMode" name="smtpOpensslVerifyMode">
                      <Select
                        clearable
                        options={[
                          { value: 'none', label: 'NONE' },
                          { value: 'peer', label: 'PEER' },
                          { value: 'client_once', label: 'CLIENT ONCE' },
                          { value: 'fail_if_no_peer_cert', label: 'FAIL IF NO PEER CERT' },
                        ]}
                      />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpEnableStarttlsAuto" name="smtpEnableStarttlsAuto">
                      <Select
                        clearable
                        options={[
                          { value: true, label: 'TRUE' },
                          { value: false, label: 'FALSE' },
                        ]}
                      />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpSsl" name="smtpSsl">
                      <Select
                        clearable
                        options={[
                          { value: true, label: 'TRUE' },
                          { value: false, label: 'FALSE' },
                        ]}
                      />
                    </Field>
                  </div>
                  <div className="grid__item width-6-12 space--bottom-2">
                    <Field label="Settings.smtpTls" name="smtpTls">
                      <Select
                        clearable
                        options={[
                          { value: true, label: 'TRUE' },
                          { value: false, label: 'FALSE' },
                        ]}
                      />
                    </Field>
                  </div>
                </div>
              }
            </div>
            {
              error &&
                <div className="form__global-error">
                  {this.t(error.error, error.meta)}
                </div>
            }
            <SubmitButton
              dirty={dirty}
              className="button button--secondary"
              submitting={submitting}
              label="Settings.submit"
            />
          </Form>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Cf7Settings.jsx